/**
 * ч.1334: порівняння двох текстів статті за рядками — щоб редактор бачив, що саме змінив агент
 * чи база знань, а не перечитував статтю цілком. Найдовша спільна підпослідовність рядків
 * (статті — до кількох сотень рядків, квадратна таблиця тут дешева).
 */
export type DiffLine = { kind: 'same' | 'add' | 'del'; text: string };

export function lineDiff(before: string, after: string): DiffLine[] {
  const a = (before ?? '').replace(/\r\n/g, '\n').split('\n');
  const b = (after ?? '').replace(/\r\n/g, '\n').split('\n');
  const n = a.length;
  const m = b.length;
  const w = m + 1;
  // lcs[i * w + j] — довжина спільної частини a[i..] і b[j..].
  const lcs = new Int32Array((n + 1) * w);
  for (let i = n - 1; i >= 0; i -= 1) {
    for (let j = m - 1; j >= 0; j -= 1) {
      lcs[i * w + j] = a[i] === b[j]
        ? (lcs[(i + 1) * w + j + 1] ?? 0) + 1
        : Math.max(lcs[(i + 1) * w + j] ?? 0, lcs[i * w + j + 1] ?? 0);
    }
  }
  const out: DiffLine[] = [];
  let i = 0;
  let j = 0;
  while (i < n && j < m) {
    const x = a[i] ?? '';
    const y = b[j] ?? '';
    if (x === y) { out.push({ kind: 'same', text: x }); i += 1; j += 1; }
    else if ((lcs[(i + 1) * w + j] ?? 0) >= (lcs[i * w + j + 1] ?? 0)) { out.push({ kind: 'del', text: x }); i += 1; }
    else { out.push({ kind: 'add', text: y }); j += 1; }
  }
  for (; i < n; i += 1) out.push({ kind: 'del', text: a[i] ?? '' });
  for (; j < m; j += 1) out.push({ kind: 'add', text: b[j] ?? '' });
  return out;
}

/** Скільки рядків додано і прибрано. */
export function diffStat(lines: DiffLine[]): { add: number; del: number } {
  return {
    add: lines.filter((l) => l.kind === 'add' && l.text.trim()).length,
    del: lines.filter((l) => l.kind === 'del' && l.text.trim()).length,
  };
}
